import constants from '../constants'
import util, {getDesignThumb} from '../util'

class Tag {
    constructor (data) {
        this.id = data.id;
        this.name = data.name;
        this.friendly = data.friendly;
    }
}

class LightDesign {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.selected = data.selected;
        this.classic = data.classic;
        this.size = data.size;
        this.visible = true;
    }
}

class Design {
    constructor (data, sizes) {
        this.id = data.id;
        this.name = data.name;
        this.url = data.url;
        this.size = data.size;
        this.type = data.type;
        this.status = data.status;
        this.pageCount = data.pageCount;

        // Update all S3 paths to HTTPS
        data.html = data.html ? data.html.replace(constants.S3_PATH_REGEX, constants.SECURE_S3_PATH) : '';

        this.html = data.html;
        this.colors = data.colors;
        this.fonts = data.fonts;
        this.updatedDate = data.updatedDate;
        this.memberId = data.memberId;
        this.ownerId = data.ownerId;
        this.defaultThumbnailPath = getDesignThumb(this.id, this.memberId);
        this.isVisible = true;
        this.removed = data.removed;
        this.appVersion = data.appVersion;
        this.hasChanges = data.hasChanges;
        this.assignedTo = data.assignedTo;
        this.lastSavedTag = data.lastSavedTag;
        this.templateId = data.templateId;
        this.locationId = data.locationId;
        this.hasVideo = data.hasVideo;

        this.width = data.width;
        this.height = data.height;
        this.unit = data.unit;

        this.isCustomSize = data.size === 'custom';

        this.isChangingStatus = false;

        this.free = data.free;

        this.folders = data.folders;

        this.sizeLabel = this.size;
        if (sizes) {
            const found = sizes.find(it => it.key === this.size);
            if (found) {
                this.sizeLabel = found.label + ' ' + found.width + ' x ' + found.height;
            }
        }
        this.tags = [];
        if (data.tags) {
            this.tags = data.tags.map(it => new Tag(it));
        }
        this.posAutoUpdateCount = data.posAutoUpdateCount;
        this.posUpdatedEnabled = data.posUpdatedEnabled;
        this.dsaUpdatedEnabled = data.dsaUpdatedEnabled;
        this.isFavorite = data.isFavorite;
    }
}

class PremiumImage {
    constructor (data) {
        this.id = data.id;
        this.ratio = data.aspect;
        this.thumbnail = data.assets.large_thumb.url;
        this.preview = data.assets.preview.url;
    }
}

class FreeImage {
    constructor (data) {
        this.id = data.id;
        this.assetId = data.assetId;
        this.name = data.name;
        this.description = data.description;
        this.downloads = data.downloads;
        this.keywords = data.keywords;
        this.categoryId = data.categoryId;
        this.s3Path = data.s3Path;
        this.privacy = data.privacy !== null ? data.privacy : 'public';
        this.popular = data.popular !== null ? data.popular : false;
        this.isFavorite = data.isFavorite;
        this.categoryIdList = [];
        if (data.categoryIdList) {
            this.categoryIdList = data.categoryIdList.split(',').map(cat => parseInt(cat));
        }
        this.imageTags = [];
        if (data.imageTags) {
            try {
                let json = JSON.parse(data.imageTags);
                this.imageTags = json.map(it => new Tag(it));
            } catch {
                return;
            }
        }
    }
}

class Revision {
    constructor (data) {
        this.id = data.id;
        this.html = data.html;
        this.updatedDate = data.updatedDate;
        this.label = data.label;
        this.isActive = false;
    }
}

class Category {
    constructor (data) {
        this.id = data.id;
        this.name = data.name;
        this.friendly = data.friendly;
    }
}

class DesignIllustration {
    constructor (data) {
        this.id = data.id;
        this.name = data.name;
        this.path = data.path;
        this.content = data.content;
        this.configuration = data.configuration;
        this.privacy = data.privacy;
        this.popular = data.popular;
        this.memberId = data.memberId;
        this.templateId = data.templateId;
        this.createdDate = data.createdDate;
        this.updatedDate = data.updatedDate;
        this.isFavorite = data.isFavorite;
        // this.isSvg = !!data.content;
        this.isSvg = true;

        this.thumbnailPath = "";
        if (data.s3Path) {
            this.thumbnailPath = constants.SECURE_S3_PATH + data.s3Path;
        } else {
            this.thumbnailPath = constants.RENDERER_DOMAIN + "/illustration/thumbnail/" + this.id + "?width=200&update=" + this.updatedDate;
        }

        this.tags = [];
        if (data.tags) {
            this.tags = data.tags.map(it => new DesignIllustrationTag(it));
        }

        this.folders = [];
        if (data.folders) {
            this.folders = data.folders.map(it => new DesignIllustrationFolder(it));
        }
    }
}

class DesignIllustrationTag {
    constructor (data) {
        this.id = data.id;
        this.name = data.name;
        this.friendly = data.friendly;
    }
}

class DesignIllustrationFolder {
    constructor (data) {
        this.id = data.id;
        this.name = data.name;
        this.friendly = data.friendly;
    }
}

class MenuObject {
    constructor (data) {
        this.id = data.id;
        this.config = JSON.parse(data.config);
        this.content = JSON.parse(data.content);
    }
}

export default {
    Tag,
    LightDesign,
    Design,
    PremiumImage,
    FreeImage,
    Revision,
    Category,
    DesignIllustration,
    DesignIllustrationTag,
    DesignIllustrationFolder,
    MenuObject
}
